// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3Gp37","rootCenter":"LoadMoreObserver_rootCenter__b_oRy","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__bX7CG"};